import React, {useEffect, useRef, useState} from "react";
import piezometerLocations from "../data/piezometerLocation.json"
import { loadModules } from "esri-loader";
import {Input} from "../components/ui/Input";
import {Button} from "../components/ui/Button";
import pzDataJSON from "../data/pzData.json"
import {ChatContainer, Message, MessageInput, MessageList} from "@chatscope/chat-ui-kit-react";

const API_KEY="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"

function TestOnePage() {
    // const [query, setQuery] = useState("");
    // const [response, setResponse] = useState("");
    //
    // const handleSearch = async () => {
    //     const apiKey = API_KEY;
    //     const apiUrl = "https://api.openai.com/v1/chat/completions";
    //
    //     const messages = [
    //         { role: "system", content: `You are a chatbot that only answers based on the following data: ${JSON.stringify(pzDataJSON)}` },
    //         { role: "user", content: query }
    //     ];
    //
    //     try {
    //         const res = await fetch(apiUrl, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 Authorization: `Bearer ${apiKey}`,
    //             },
    //             body: JSON.stringify({
    //                 model: "gpt-4",
    //                 messages: messages,
    //             }),
    //         });
    //
    //         const data = await res.json();
    //         setResponse(data.choices[0]?.message?.content || "No response from ChatGPT.");
    //     } catch (error) {
    //         setResponse("Error fetching response.");
    //     }
    // };

    const [messages, setMessages] = useState([]);

    const handleSend = async (query) => {
        const apiKey = API_KEY;
        const apiUrl = "https://api.openai.com/v1/chat/completions";

        const userMessage = { sender: "user", direction: "outgoing", message: query };
        setMessages((prev) => [...prev, userMessage]);

        const messagesPayload = [
            { role: "system", content: `You are a chatbot that only answers based on the following data: ${JSON.stringify(pzDataJSON)}` },
            { role: "user", content: query }
        ];

        try {
            const res = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiKey}`,
                },
                body: JSON.stringify({
                    model: "gpt-4",
                    messages: messagesPayload,
                }),
            });

            const data = await res.json();
            const botMessage = {
                sender: "bot",
                direction: "incoming",
                message: data.choices[0]?.message?.content || "No response from ChatGPT.",
            };
            setMessages((prev) => [...prev, botMessage]);
        } catch (error) {
            setMessages((prev) => [...prev, { sender: "bot", direction: "incoming", message: "Error fetching response." }]);
        }
    };


    return (
        <div style={{height: "500px", width: "400px", margin: "auto"}}>
            <ChatContainer>
                <MessageList>
                    {messages.map((msg, index) => (
                        <Message key={index} model={msg}/>
                    ))}
                </MessageList>
                <MessageInput placeholder="Ask about pzData..." onSend={handleSend}/>
            </ChatContainer>
        </div>
    );

}

export default TestOnePage;